import React, { useEffect } from 'react';

const WebTabs = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: WebTabs is not implemented yet.');
  }, []);
  return (
    <>
  { /*WebTabs */} 
 </>
  );
};

export default WebTabs;
